var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-xl"},[_c('Card',{attrs:{"title":"Categorias","subtitle":""}},[_c('table',{staticClass:"table table-sm table-hover table-striped"},[_c('thead',[_c('tr',[_c('PkHeader'),_c('EditHeader'),_c('DeleteHeader'),_c('StatusHeader'),_c('th',{attrs:{"data-column-id":"name"}},[_vm._v("Nome")])],1)])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }